/**
 * O que a aba mostra quando a moldura não entregou a ficha aberta (a prop `ficha`).
 *
 * NÃO EXISTE NO LEGADO, e não é para existir em uso: é a trava de integração do contrato
 * `PropsDaAba` (`comum-ficha/tipos.ts`). Sem a ficha, a aba não sabe qual atendimento está aberto,
 * e consultar só pela cliente mostraria (ou gravaria) dado do atendimento errado. Então ela não
 * consulta nada e diz por quê, em vez de desenhar uma aba vazia que pareceria "sem dado".
 */

// O estado de erro do Chassi.
import { EstadoErro } from '@complexity/ui';

export function AbaSemFicha({ aba }: { readonly aba: string }) {
  return (
    <EstadoErro titulo="Não foi possível abrir esta aba.">
      {`A aba ${aba} não recebeu a cliente e o atendimento abertos. Volte à lista de clientes e abra a ficha de novo.`}
    </EstadoErro>
  );
}
